import * as styles from "./EditNodeDetails.css";

export const nodeOptionsLinkStyleClass = styles.action;
